import {
    WORKSPACE_SELECTED
} from '..'
import SessionService from '../../services/session'

export default class Workspace {

    static load() {
        return (dispatch) => {
            return SessionService.getWorkspace()
                .then((workspace) => dispatch({
                        type: WORKSPACE_SELECTED,
                        payload: workspace
                    })
                )
        }
    }

    static update(payload) {
        return (dispatch) => {
            return SessionService.setWorkspace(payload)
                .finally(() => dispatch({
                        type: WORKSPACE_SELECTED,
                        payload
                    })
                )
        }
    }

    static clear() {
        return (dispatch) => {
            return SessionService.clearWorkspace()
                .finally(() => dispatch({
                    type: WORKSPACE_SELECTED,
                    payload: null
                })
            )
        }
    }
}



// WEBPACK FOOTER //
// src/actions/workspace/index.js